export enum ActivityEntryType {
  File = 'file',
  Report = 'report',
  AutomaticProcessingCode = 'apc',
  Position = 'position'
}
